import { useTranslation } from 'react-i18next';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { UserApi } from '../api/UserApi';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';

export const ExportDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const exportData = () => {
    UserApi.exportUserDetails(dispatch);
  };
  return (
    <Button
      data-testid="export-button"
      variant="contained"
      startIcon={<SystemUpdateAltIcon />}
      onClick={exportData}
      className="text-capitalize common-btn"
    >
      {t('button.export')}
    </Button>
  );
};
